import { withStyles, Button } from '@material-ui/core';
import ArrowDropDown from '@material-ui/icons/KeyboardArrowDown';
import TerminalSelectMenu from './TerminalSelectMenu';
import { useState } from 'react';
import Tooltip from '../../../../../common/StyledToolTip';

const styles = (theme) => ({
  terminalContainer: {
    flex: "auto",
    marginRight: 4,
  },
  wrapper: {
    height: 42,
    border: `1px solid ${theme.iconColor}`,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 4,
    fontSize: theme.textFontSize,
    cursor: 'pointer',
    color: theme.TextColor,
    justifyContent: 'space-between',
    width: '100%',
    '&:focus': {
      background: theme.ModalBGColor
    }
  },
  buttonIcon: {
    marginLeft: 8,
    fontSize: 26,
    color: theme.iconColor
  },
  containerLabelClass: {
    position: 'absolute',
    padding: '0 4',
    backgroundColor: theme.ModalBGColor,
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    transform: `translate(-18px, -21px) scale(0.75)`
  },
  terminalName: {
    textAlign: 'left'
  }
});

const getTrimmedValueOfSelectedTerminals = (selectedTerminals) => {
  const maxDisplayLength = 32;
  return (
    selectedTerminals.substring(0, maxDisplayLength) +
      (selectedTerminals.length > maxDisplayLength ? '...' : '') || 'Select...'
  );
};

const TerminalSelectInput = ({
  classes,
  terminalOptions,
  selectedTerminals,
  selectedNonAssignedTerminals,
  onTerminalChange
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const onTerminalClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closeTerminalMenu = () => {
    setAnchorEl(null);
  };
  const commaSeparatedSelectedTerminals = selectedNonAssignedTerminals.join(', ');
  return (
    <div className={classes.terminalContainer}>
      <Button disableRipple className={classes.wrapper} onClick={onTerminalClick}>
        <span className={classes.containerLabelClass}>Terminal (Optional)</span>
        <Tooltip title={commaSeparatedSelectedTerminals}>
          <span className={classes.terminalName}>
            {getTrimmedValueOfSelectedTerminals(commaSeparatedSelectedTerminals)}
          </span>
        </Tooltip>
        <ArrowDropDown className={classes.buttonIcon} />
      </Button>
      {anchorEl && (
        <TerminalSelectMenu
          anchorEl={anchorEl}
          selectedTerminalsData={selectedTerminals}
          closeTerminalMenu={closeTerminalMenu}
          terminalOptions={terminalOptions}
          onTerminalChange={onTerminalChange}
        />
      )}
    </div>
  );
};

export default withStyles(styles)(TerminalSelectInput);
